var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 5.00001V5.75001C23.25 5.84947 23.2105 5.94485 23.1402 6.01518C23.0698 6.0855 22.9745 6.12501 22.875 6.12501H21.75V6.68751C21.75 6.99815 21.4981 7.25001 21.1875 7.25001H2.8125C2.50186 7.25001 2.25 6.99815 2.25 6.68751V6.12501H1.125C1.02554 6.12501 0.930161 6.0855 0.859835 6.01518C0.789509 5.94485 0.75 5.84947 0.75 5.75001V5.00001C0.750001 4.92582 0.772007 4.8533 0.813234 4.79162C0.854462 4.72994 0.913058 4.68188 0.981609 4.65351L11.8566 0.528513C11.9484 0.490496 12.0516 0.490496 12.1434 0.528513L23.0184 4.65351C23.0869 4.68188 23.1455 4.72994 23.1868 4.79162C23.228 4.8533 23.25 4.92582 23.25 5.00001ZM22.125 19.25H1.875C1.25367 19.25 0.75 19.7537 0.75 20.375V21.125C0.75 21.2245 0.789509 21.3199 0.859835 21.3902C0.930161 21.4605 1.02554 21.5 1.125 21.5H22.875C22.9745 21.5 23.0698 21.4605 23.1402 21.3902C23.2105 21.3199 23.25 21.2245 23.25 21.125V20.375C23.25 19.7537 22.7463 19.25 22.125 19.25ZM4.5 8.00001V17H2.8125C2.50186 17 2.25 17.2519 2.25 17.5625V18.5H21.75V17.5625C21.75 17.2519 21.4981 17 21.1875 17H19.5V8.00001H16.5V17H13.5V8.00001H10.5V17H7.5V8.00001H4.5Z",
    fill: "#0083DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.79ab784722fdb902b2968713fba813ac.svg";
export { ForwardRef as ReactComponent };